export const ERROR_DEFAULTS = {
    errorMessage: '',
}
